/**
 * Stand-in for a routed page that has a path but no screen yet. The route
 * table (App.tsx) registers every Life OS path with one of these so links,
 * deep links and the SPA fallback work before the real page lands; the page
 * bundle then swaps the element, never the path.
 */
export default function Placeholder({
  title,
  note,
  kicker = 'Coming soon',
}: {
  title: string;
  note?: string;
  kicker?: string;
}): JSX.Element {
  return (
    <>
      <header className="page-head">
        <h1 className="page-head__title">{title}</h1>
      </header>
      <div className="placeholder">
        <div className="placeholder__soon">{kicker}</div>
        <p>{note ?? `${title} lands in a later build.`}</p>
      </div>
    </>
  );
}
